// web/src/lib/zitchAgent/_protocol.ts —— 内部：SIP from 头解析等协议工具
// 拆自 web/src/lib/zitchAgent.ts 的同名分区（内容原样搬运）；由 web/src/lib/zitchAgent.ts 以 export * 聚合，导出面对调用方不变。

/** 从 sip:138@carrier 提取号码 */
export function parseFrom(from: string): string {
  const m = /sip:([^@\s>]+)/.exec(from || '');
  return m ? m[1] : from || '';
}

